// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"8fb132bd","977":"f13299d8"}[chunkId] + ".chunk.js";
};